import { render } from "./AppButton.vue?vue&type=template&id=28d6d647&scoped=true"
const script = {}

import "./AppButton.vue?vue&type=style&index=0&id=28d6d647&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d6d647"]])

export default __exports__